module.exports = __webpack_public_path__ + "static/media/40_A.37e570a4.png";